import { TabBar } from "components/TabBar/TabBar";
import { useFetchUsernames } from "hooks/useFetchUsernames";
import { Filter } from "model/Filter/Filter";
import { getGroupMemberCount } from "model/Group/Group";
import { GroupData } from "pages/PickemGroup/PickemGroupPage";
import { selectUsername } from "selectors/User";
import { FlexRow } from "styles/layout";
import {
  HeaderContainer,
  TabsContainer,
  GroupName,
  DetailsContainer,
  OwnerName,
  MemberCount,
  GroupCode,
} from "./styles";
import { useAppSelector } from "app/hooks";

interface Props {
  groupData: GroupData;
  groupId: string;
  tabFilter?: Filter<string>;
}

export const GroupHeader = ({ groupData, groupId, tabFilter }: Props) => {
  const ownerUid = groupData.group?.ownerUid;
  useFetchUsernames(!!ownerUid ? [ownerUid] : []);
  const ownerUsername = useAppSelector((state) =>
    selectUsername(state, ownerUid)
  );

  const memberCount = !!groupData.group
    ? getGroupMemberCount(groupData.group)
    : undefined;

  return (
    <HeaderContainer>
      <DetailsContainer>
        <FlexRow>
          <GroupName>{groupData.groupName}</GroupName>
          <GroupCode>Code: {groupId.toUpperCase()}</GroupCode>
        </FlexRow>
        {!!ownerUsername && <OwnerName>Owner: {ownerUsername}</OwnerName>}
        {!!memberCount && (
          <MemberCount>
            {memberCount} Member{memberCount > 1 ? "s" : ""}
          </MemberCount>
        )}
      </DetailsContainer>
      {!!tabFilter && tabFilter.options.length > 1 && (
        <TabsContainer>
          <TabBar filter={tabFilter} />
        </TabsContainer>
      )}
    </HeaderContainer>
  );
};
